// import React from 'react';
import styled from 'styled-components';

export const Title = styled.h3({ top: '20%', color: '#66bb66' });
export const DungeonLevelTitle = styled.div({
  top: '10%',
  color: '#bbb',
  fontFamily: 'monospace'
});
